import { Stack, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { LANG } from '../../../language/lang';
import { useSelector } from 'react-redux';

const BtnBox = ({ isMobile }) => {
    const isAuth = useSelector(state => state.user.isAuth);
   return (
        <Stack direction="row" spacing={2} alignItems="center">

            {isAuth ?
                <>
                <Button
                        size={isMobile ? "small" : "medium"}
                        component={Link} to="/cabinet"
                        variant="contained">{LANG("BTN_TOP_BAR_CABINET")}</Button>
                </>
                :
                <>
                    <Button
                        size={isMobile ? "small" : "medium"}
                        component={Link} to="/auth/registration"
                        variant="text">{LANG("BTN_TOP_BAR_REGISTER")}</Button>

                    <Button
                        size={isMobile ? "small" : "medium"}
                        component={Link} to="/auth/login"
                        variant="contained">{LANG("BTN_TOP_BAR_LOGIN")}</Button>
                </>
            }


        </Stack>
    );
};

export default BtnBox;